export const useClipboard = () => {
  const copy = (text: string, callback?: () => void) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        if (callback) {
          callback();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return {
    copy,
  };
};
